import type { ReactNode } from 'react'

interface KbdProps {
  children: ReactNode
}

export function Kbd({ children }: KbdProps) {
  return (
    <kbd
      style={{
        fontFamily: 'var(--font-mono)',
        fontSize: '10.5px',
        color: 'var(--text-3)',
        border: '1px solid var(--border)',
        borderRadius: '4px',
        padding: '1px 5px',
        background: 'var(--surface)',
        lineHeight: 1.4,
      }}
    >
      {children}
    </kbd>
  )
}
